export function copyQuestion(question) {
	localStorage.setItem('copiedQuestion', JSON.stringify(question))
	return null
} 

 





// WEBPACK FOOTER //
// ./src/utils/copyPaste.js